















import Component from 'vue-class-component';
import { Vue, Prop } from 'vue-property-decorator';

@Component({
    props: ['cols', 'label', 'name', 'labelCols', 'isShow']
})
export default class DownloadInput extends Vue {    
    @Prop()
    labelCols :any;
    lCols : any = this.labelCols ? this.labelCols : 2;

    print() {
      this.$emit('print');
    }
}
